var _path, _path2, _mask, _rect, _mask2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPipelinesIsp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6C4.79667 6 5.08668 5.91203 5.33335 5.74721C5.58003 5.58238 5.77229 5.34811 5.88582 5.07403C5.99935 4.79994 6.02906 4.49834 5.97118 4.20736C5.9133 3.91639 5.77044 3.64912 5.56066 3.43934C5.35088 3.22956 5.08361 3.0867 4.79264 3.02882C4.50166 2.97094 4.20006 3.00065 3.92597 3.11418C3.65189 3.22771 3.41762 3.41997 3.2528 3.66665C3.08797 3.91332 3 4.20333 3 4.5C3 4.89783 3.15804 5.27936 3.43934 5.56066C3.72064 5.84197 4.10218 6 4.5 6ZM4.5 4C4.59889 4 4.69556 4.02932 4.77779 4.08427C4.86001 4.13921 4.9241 4.2173 4.96194 4.30866C4.99978 4.40002 5.00969 4.50056 4.99039 4.59755C4.9711 4.69454 4.92348 4.78363 4.85355 4.85355C4.78363 4.92348 4.69454 4.9711 4.59755 4.99039C4.50056 5.00969 4.40002 4.99978 4.30866 4.96194C4.2173 4.9241 4.13921 4.86001 4.08426 4.77779C4.02932 4.69556 4 4.59889 4 4.5C4 4.36739 4.05268 4.24022 4.14645 4.14645C4.24021 4.05268 4.36739 4 4.5 4Z",
    fill: "#2968C9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 18C4.79667 18 5.08668 17.912 5.33335 17.7472C5.58003 17.5824 5.77229 17.3481 5.88582 17.074C5.99935 16.7999 6.02906 16.4983 5.97118 16.2074C5.9133 15.9164 5.77044 15.6491 5.56066 15.4393C5.35088 15.2296 5.08361 15.0867 4.79264 15.0288C4.50166 14.9709 4.20006 15.0006 3.92597 15.1142C3.65189 15.2277 3.41762 15.42 3.2528 15.6666C3.08797 15.9133 3 16.2033 3 16.5C3 16.8978 3.15804 17.2794 3.43934 17.5607C3.72064 17.842 4.10218 18 4.5 18ZM4.5 16C4.59889 16 4.69556 16.0293 4.77779 16.0843C4.86001 16.1392 4.9241 16.2173 4.96194 16.3087C4.99978 16.4 5.00969 16.5006 4.99039 16.5975C4.9711 16.6945 4.92348 16.7836 4.85355 16.8536C4.78363 16.9235 4.69454 16.9711 4.59755 16.9904C4.50056 17.0097 4.40002 16.9998 4.30866 16.9619C4.2173 16.9241 4.13921 16.86 4.08426 16.7778C4.02932 16.6956 4 16.5989 4 16.5C4 16.3674 4.05268 16.2402 4.14645 16.1464C4.24021 16.0527 4.36739 16 4.5 16Z",
    fill: "#2968C9"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 26,
    height: 11,
    rx: 1
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 26,
    height: 11,
    rx: 1,
    stroke: "#2968C9",
    strokeWidth: 2.4,
    mask: "url(#path-3-inside-1)"
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 11,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 11,
    rx: 1,
    stroke: "#2968C9",
    strokeWidth: 2.4,
    mask: "url(#path-4-inside-2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinesIsp);
export default __webpack_public_path__ + "static/media/pipelines-isp.a86d9e69936a5a172058c99d4135305f.svg";
export { ForwardRef as ReactComponent };